<template>
  <b-card class="card-user mt-4">
    <b-button
      v-if="canEdit"
      variant="link"
      class="float-right"
      @click="remove()"
    >
      <font-awesome-icon icon="trash" />
    </b-button>

    <p>
      {{ user.FirstName }} {{ user.LastName }}<br />
      <small
        ><a :href="`mailto:${user.Email}`">{{ user.Email }}</a></small
      >
    </p>
    <router-link
      v-if="canEdit"
      :to="{ name: 'editSub', params: { username: user.UserName } }"
      class="btn btn-primary"
      >Gegevens wijzigen</router-link
    >
    <b-button
      v-if="canEdit && user.ContactID != contactID"
      variant="link"
      class="float-right"
      @click="promote(user.Email, user.ContactID)"
    >
      <small> Maak hoofdgebruiker </small>
    </b-button></b-card
  >
</template>

<script>
import { deleteSub, transferOwnership } from '@/services/AuthorizationService'
export default {
  props: {
    user: {
      required: true,
      type: Object,
      default: function() {
        return {}
      }
    },
    contactID: {
      required: true,
      type: Number,
      default: function() {
        return 0
      }
    },
    canEdit: {
      required: false,
      type: Boolean,
      default: true
    }
  },

  methods: {
    promote: async function() {
      let confirmed = confirm(
        `Weet u zeker dat je contactpersoon ${this.user.FirstName} ${this.user.LastName} de hoofdgebruiker wilt maken? Als u verdergaat word je uitgelogd en zal je niet langer de hoofdgebruiker zijn.`
      )

      if (confirmed === true) {
        await transferOwnership({
          subUserName: this.user.Email,
          subUserContactID: this.user.ContactID
        })
        await this.$store.commit('unsetCart')
        await this.$store.commit('unsetUser', {
          reason: 'loggedOut=true'
        })
      }
    },
    remove: async function() {
      let confirmed = confirm(
        `Weet u zeker dat je contactpersoon ${this.user.FirstName} ${this.user.LastName} wilt verwijderen?`
      )
      if (confirmed === true) {
        await deleteSub({
          subUserName: this.user.Email,
          subUserContactID: this.user.ContactID
        })
        this.$emit('updateContacts')
      }
    }
  }
}
</script>

<style></style>
